import {createFileRoute} from '@tanstack/react-router';
import {ConnectedAccountAddCallbackPage} from 'pages/service/ConnectedAccountPage/ConnectedAccountAddCallbackPage';

export const Route = createFileRoute(
  '/_protected/connected-account/add/callback',
)({
  component: ConnectedAccountAddCallbackPage,
  validateSearch: (search) => {
    return {
      status: search.status as string | undefined,
    };
  },
});
